import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react'

export type ServiceCardProps<T extends ElementType = 'a'> = {
  as?: T
  icon: ReactNode
  children: ReactNode
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children'>

export function ServiceCard<T extends ElementType = 'a'>({
  as,
  icon,
  children,
  className,
  ...rest
}: ServiceCardProps<T>) {
  const Component = (as || 'a') as ElementType
  const classes = ['azoya-service-card', className].filter(Boolean).join(' ')
  return (
    <Component className={classes} {...rest}>
      <span className="azoya-service-icon">{icon}</span>
      <span>{children}</span>
    </Component>
  )
}
